<script setup>
import packageFile from '../../package.json'

const yearToday = new Date().toISOString().substring(0, 4)
const appVersion = packageFile.version
</script>

<template>
  <div class="pt-4 pb-3" />
  <div class="position-fixed bottom-0 bg-light w-100 d-flex justify-content-between container-fluid small pt-1">
    <div>
      © 2012-{{ yearToday }}
      <a
        href="https://Lastware.cz/"
        class="text-dark"
      >
        Lastware sro.
      </a>
    </div>
    <div>
      F4C v. {{ appVersion }}
    </div>
  </div>
</template>
